import { Control, FormState } from 'react-hook-form';
import TextInput from './TextInput';
import SelectMenu from './SelectMenu';
import validationUtils from '../../services/validationUtils';
import { StateCode } from '../../data/models/state-code.model';
import { useTranslation } from 'react-i18next';

interface AddressProps {
  namePrefix: string;
  control: Control;
  formState: FormState<any>;
  requiredFieldMessage: string;
  stateCodes: StateCode[];
  lineOneLabel?: string;
}

export default function Address({
  namePrefix,
  control,
  formState,
  requiredFieldMessage,
  stateCodes,
  lineOneLabel,
}: AddressProps) {
  const { t } = useTranslation('common');

  return (
    <>
      <TextInput
        label={lineOneLabel || t('common.address1')}
        name={namePrefix + 'AddressLine1'}
        required={true}
        control={control}
        errors={formState.errors}
        rules={{ required: requiredFieldMessage }}
        inputProps={{ maxLength: 200 }}
      />
      <TextInput
        label={t('common.address2')}
        name={namePrefix + 'AddressLine2'}
        required={false}
        control={control}
        errors={formState.errors}
        inputProps={{ maxLength: 200 }}
      />
      <TextInput
        label={t('common.city')}
        name={namePrefix + 'City'}
        required={true}
        control={control}
        errors={formState.errors}
        rules={{ required: requiredFieldMessage }}
        inputProps={{ maxLength: 100 }}
      />
      <SelectMenu
        label={t('common.state')}
        name={namePrefix + 'State'}
        values={stateCodes}
        valueAttr="stateCode"
        labelAttr="stateName"
        required={true}
        control={control}
        errors={formState.errors}
        rules={{ required: requiredFieldMessage }}
      />
      <TextInput
        label={t('common.zip')}
        name={namePrefix + 'ZipCode'}
        required={true}
        control={control}
        errors={formState.errors}
        rules={{
          required: requiredFieldMessage,
          pattern: validationUtils.zipCodeValidation(),
        }}
        inputProps={{ maxLength: 10 }}
      />
    </>
  );
}
